export const card = {
    padding: "25px",
    background: "white",
    borderBottomRightRadius: "25px",
    borderBottomLeftRadius: "25px",
};
export const userCard = {
    display: "flex",
    gap: 2,
    background: "#F8F8F8",
    padding: "10px",
    borderRadius: "25px",
};
export const documentContainer = {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    marginTop: "25px",
};
